import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MixPanelServiceTsService } from '../../services/mix-panel.service';
import { WelcomeDialogComponent } from '../welcome-dialog/welcome-dialog.component';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { Drawer } from 'primeng/drawer';
import { AuthService } from '../../services/auth.service';
import { Renderer2 } from '@angular/core';
import { configLanguage } from '../../shared/utils/language.util';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.css',
    standalone: false
})
export class HomeComponent implements OnInit {
  @ViewChild('drawerRef') drawerRef!: Drawer;
  items: MenuItem[] | undefined;
  itemsProfile: MenuItem[] | undefined;
  itemsConfig: MenuItem[] | undefined;
  browserLanguage: string | null = '';
  visible: boolean = true;
  isAdminView: boolean = false;
  adminDrawer: boolean = false;
  showTerms: boolean = false;
  
  expensesData: any;
  incomeData: any;
  chartOptions: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private translocoService: TranslocoService,
    private mixPanelService: MixPanelServiceTsService,
    private router: Router,
    private titleService: Title,
    private authService: AuthService,
  ){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkUrl();
      }
    });
  }

  ngOnInit(): void {
    this.renderer.setStyle(document.body, 'background-color', '#F0F5F9');
    this.setupMenu();
    this.setupLanguage();
    this.checkUrl();

    window.addEventListener('resize', () => {
      this.isMdOrSm();
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeStyle(document.body, 'background-color');
  }

  isMdOrSm(): boolean {
    return window.innerWidth <= 768;
  }

  checkUrl(){
    const currentUrl = this.router.url.split('/').pop() || '';
    if (currentUrl === 'home') {
      this.changeTitle('Home');
      this.isAdmin(false);
    } else if (currentUrl === 'lancamentos') {
      this.changeTitle('Lançamentos');
      this.isAdmin(false);
    } else if (currentUrl === 'investimentos') {
      this.changeTitle('Investimentos');
      this.isAdmin(false);
    } else if (currentUrl === 'users') {
      this.changeTitle('Usuários');
      this.isAdmin(true);
    } else if (currentUrl === 'groups') {
      this.changeTitle('Agrupadores');
      this.isAdmin(true);
    }else{
      this.isAdmin(true);
    }
  }

  isAdmin(isAdmin: boolean){
    if (isAdmin) {
      this.isAdminView = true;
      this.visible = false;
    }else{
      this.isAdminView = false;
      this.visible = true;
      this.adminDrawer = false;
    }
  }

  openMenu(){
    if (this.isAdminView) {
      this.adminDrawer = !this.adminDrawer;
    }else{
      this.visible = !this.visible;
    }
  }

  private setupMenu() {
    this.translocoService.selectTranslateObject('home-component').subscribe(value => {
      this.items = [
        { 
          label: value.home, 
          icon: 'pi pi-home',
          routerLink: '/home'
        },
        { 
          label: value.accountingEntries, 
          icon: 'pi pi-wallet',
          routerLink: '/home/lancamentos'
        },
        {
          label: value.investment,
          icon: 'pi pi-dollar',
          routerLink: '/home/investimentos'
        }
      ];
      this.itemsConfig = [
        {
          label: value.configs,
          items: [
            {
              label: value.companies,
              routerLink: '/home/empresas'
            },
            {
              label: value.users,
              routerLink: '/home/usuarios'
            },
            {
              label: value.groups,
              routerLink: '/home/agrupadores'
            },
            {
              label: value.conections,
              routerLink: '/home/conexoes'
            }
          ]
        }
      ];

      this.itemsProfile = [
        {
          label: value.lang.title,
          icon: 'pi pi-book',
          items: [
            {
              label: value.lang.ptBr,
              state: { flag: 'https://flagcdn.com/br.svg' },
              command: () => {
                configLanguage('pt-br', this.translocoService);
              }
            },
            {
              label: value.lang.enUs,
              state: { flag: 'https://flagcdn.com/us.svg' },
              command: () => {
                configLanguage('en-us', this.translocoService);
              }
            },
            {
              label: value.lang.esMx,
              state: { flag: 'https://flagcdn.com/es.svg' },
              command: () => {
                configLanguage('es-mx', this.translocoService);
              }
            }
          ]
        },
        { 
          label: value.exit, 
          icon: 'pi pi-sign-out', 
          command: () => {
            this.logout();
          }
        }
      ];
    });

    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  private handleResize() {
    if (!this.isAdminView) {
      const mdBreakpoint = 960;
      this.visible = window.innerWidth > mdBreakpoint;
    }
  }

  private setupLanguage() {
    this.mixPanelService.trackScreenView('Registration');
    if (isPlatformBrowser(this.platformId)) {
      this.browserLanguage = localStorage.getItem('browserLanguage');
      if (this.browserLanguage) {
        this.translocoService.setActiveLang(this.browserLanguage);
      }
    }
  }

  openDialog(dialog: WelcomeDialogComponent) {
    dialog.showDialog();
  }

  toggleDropdown(): void {
    this.visible = !this.visible;
  }

  logout(){
    this.authService.logout();
  }

  changeTitle(value:string){
    this.titleService.setTitle(`Total Cash - ${value}`);
  }
}
